var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 6.9996H11.8125C12.2189 7.00738 12.6194 6.90178 12.9691 6.69465C13.3188 6.48752 13.6039 6.18705 13.7924 5.82695C13.9809 5.46685 14.0653 5.06135 14.0362 4.65594C14.0071 4.25053 13.8657 3.86124 13.6277 3.53174C13.3897 3.20224 13.0647 2.94555 12.689 2.79048C12.3133 2.6354 11.9018 2.58807 11.5007 2.65378C11.0996 2.7195 10.7247 2.89567 10.4181 3.16253C10.1115 3.42939 9.88538 3.77639 9.765 4.1646M2.625 10.4996H16.1875C16.5939 10.4918 16.9944 10.5974 17.3441 10.8046C17.6938 11.0117 17.9789 11.3121 18.1674 11.6722C18.3559 12.0324 18.4403 12.4379 18.4112 12.8433C18.3821 13.2487 18.2407 13.638 18.0027 13.9675C17.7647 14.297 17.4397 14.5536 17.064 14.7087C16.6883 14.8638 16.2768 14.9111 15.8757 14.8454C15.4746 14.7797 15.0997 14.6035 14.7931 14.3367C14.4865 14.0698 14.2604 13.7228 14.14 13.3346M3.5 13.9996H8.3125C8.71888 13.9918 9.11939 14.0974 9.4691 14.3046C9.81882 14.5117 10.1039 14.8121 10.2924 15.1722C10.4809 15.5324 10.5653 15.9379 10.5362 16.3433C10.5072 16.7487 10.3657 17.138 10.1277 17.4675C9.88974 17.797 9.56467 18.0536 9.18896 18.2087C8.81325 18.3638 8.40177 18.4111 8.00067 18.3454C7.59956 18.2797 7.2247 18.1035 6.91812 17.8367C6.61155 17.5698 6.38538 17.2228 6.265 16.8346",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoff);
export default __webpack_public_path__ + "static/media/timeoff.241170ba7a16f09ddef505dbd5df3339.svg";
export { ForwardRef as ReactComponent };